import React from 'react';
import { StyleSheet, Text, View, TouchableOpacity, Image } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import { scale } from '../../../utils/scale.utils';
import BaseText from '../../BaseText';
import Icon from '../../Icon';

const TravelerItem = ({ item, onPress }) => {
  return (
    <TouchableOpacity style={stylesItem.container} onPress={onPress}>
      <Image style={stylesItem.image} source={{ uri: 'https://picsum.photos/100' }} />
      <View style={stylesItem.content}>
        <BaseText style={stylesItem.name}>{item.name}</BaseText>
        <BaseText style={CommonStyles.small}>{item.desc}</BaseText>
      </View>
      <View style={CommonStyles.justifyCenter}>
        <View style={stylesItem.check}>
          {item.checked ? <Icon name="check" size={scale(10)} color={Color.primary} /> : null}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const stylesItem = StyleSheet.create({
  container: {
    ...CommonProperties.p3,
    flexDirection: 'row',
  },
  image: {
    width: scale(48),
    height: scale(48),
    borderRadius: scale(24),
  },
  content: {
    flex: 1,
    ...CommonProperties.px3,
  },
  name: {
    ...CommonProperties.mb2,
    ...CommonProperties.h3,
  },
  check: {
    width: scale(16),
    height: scale(16),
    borderRadius: scale(4),
    borderColor: '#b3b3b3',
    borderWidth: 2,
    ...CommonProperties.centerAlignment,
  },
});

export default TravelerItem;
